module.exports = require('./helpers/bundle-url').getBundleURL('hmjwG') + "gce-logo.562570c9.png";